/* Naoto Kumagai: header panels, featured slideshow, accordion, filters and add to cart. */
(function () {
  const ready = (fn) =>
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  function initHeader() {
    const header = document.querySelector('[data-nk-header]');
    if (!header || header.dataset.nkReady) return;
    header.dataset.nkReady = '1';

    const panels = {
      about: header.querySelector('[data-nk-panel="about"]'),
      locale: header.querySelector('[data-nk-panel="locale"]'),
      menu: header.querySelector('[data-nk-panel="menu"]'),
    };
    const toggles = {
      about: header.querySelector('[data-nk-toggle="about"]'),
      locale: header.querySelector('[data-nk-toggle="locale"]'),
      menu: header.querySelector('[data-nk-toggle="menu"]'),
    };

    const set = (name, open) => {
      if (!panels[name]) return;
      panels[name].hidden = !open;
      if (toggles[name]) toggles[name].setAttribute('aria-expanded', String(open));
    };
    const isOpen = (name) => panels[name] && !panels[name].hidden;
    const only = (name, open) => {
      Object.keys(panels).forEach((key) => set(key, key === name ? open : false));
    };

    if (toggles.about) {
      toggles.about.addEventListener('click', (event) => {
        event.preventDefault();
        only('about', !isOpen('about'));
      });
      toggles.about.addEventListener('mouseenter', () => {
        if (!isOpen('about')) only('about', true);
      });
    }

    header.querySelectorAll('.nk-header__link:not([data-nk-toggle])').forEach((link) => {
      link.addEventListener('mouseenter', () => set('about', false));
    });
    header.addEventListener('mouseleave', () => set('about', false));

    if (toggles.locale) toggles.locale.addEventListener('click', () => only('locale', !isOpen('locale')));
    if (toggles.menu) toggles.menu.addEventListener('click', () => only('menu', !isOpen('menu')));

    header.querySelectorAll('[data-nk-close]').forEach((button) => {
      button.addEventListener('click', () => only(null, false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') only(null, false);
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) only(null, false);
    });

    header.querySelectorAll('[data-nk-locale-form] select').forEach((select) => {
      select.addEventListener('change', () => select.form.submit());
    });
  }

  function initSlideshows() {
    document.querySelectorAll('[data-nk-feat]').forEach((root) => {
      if (root.dataset.nkReady) return;
      root.dataset.nkReady = '1';

      const slides = Array.from(root.querySelectorAll('[data-nk-slide]'));
      if (slides.length === 0) return;

      const count = root.querySelector('[data-nk-feat-count]');
      const title = root.querySelector('[data-nk-feat-title]');
      const year = root.querySelector('[data-nk-feat-year]');
      const caption = root.querySelector('[data-nk-feat-caption]');
      const stage = root.querySelector('[data-nk-feat-stage]');
      const narrow = window.matchMedia('(max-width: 759px)');
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;

      const load = (i) => {
        const slide = slides[(i + slides.length) % slides.length];
        /* Smartphone crops first, so the picture element picks the right file. */
        slide.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });
        const img = slide.querySelector('img[data-src]');
        if (!img) return;
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
      };

      /* On screens up to 759px a slide may name another work (Title / Year
         for smartphone); otherwise both sizes share the same caption. */
      const setCaption = () => {
        const data = slides[index].dataset;
        const sp = narrow.matches;
        if (title) title.textContent = (sp && data.titleSp) || data.title || '';
        if (year) year.textContent = (sp && data.yearSp) || data.year || '';
      };

      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
        load(index);
        load(index + 1);
        load(index - 1);

        const data = slides[index].dataset;
        setCaption();
        if (caption) {
          if (data.href) caption.setAttribute('href', data.href);
          else caption.removeAttribute('href');
        }
        if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      };

      /* Crossing the 759px breakpoint (a PC window made narrow, or wide again)
         changes the layout and, for slides with a smartphone image, the file
         and possibly the caption. Hide the frame and the caption text at once
         and fade them back in when the shown image is ready. */
      const fading = [stage, title, year].filter(Boolean);
      let swapTimer = null;
      const onBreakpoint = () => {
        setCaption();
        if (!stage || calm.matches) return;
        fading.forEach((el) => el.classList.add('is-swapping'));
        clearTimeout(swapTimer);
        const img = slides[index].querySelector('img');
        const swaps = !!slides[index].querySelector('source[srcset]');
        let done = false;
        const reveal = () => {
          if (done) return;
          done = true;
          clearTimeout(swapTimer);
          if (img) img.removeEventListener('load', reveal);
          requestAnimationFrame(() =>
            requestAnimationFrame(() => fading.forEach((el) => el.classList.remove('is-swapping')))
          );
        };
        if (img && swaps) {
          /* The browser loads the other file; reveal when it arrives, or after 1.5s at most. */
          img.addEventListener('load', reveal);
          swapTimer = setTimeout(reveal, 1500);
        } else {
          /* Same file, new crop: just let the layout settle. */
          swapTimer = setTimeout(reveal, 120);
        }
      };
      if (narrow.addEventListener) narrow.addEventListener('change', onBreakpoint);
      else if (narrow.addListener) narrow.addListener(onBreakpoint);

      stage?.addEventListener('click', () => show(index + 1));
      root.querySelector('[data-nk-feat-next]')?.addEventListener('click', () => show(index + 1));
      root.querySelector('[data-nk-feat-prev]')?.addEventListener('click', () => show(index - 1));

      document.addEventListener('keydown', (event) => {
        if (event.target instanceof HTMLElement && event.target.closest('input, select, textarea')) return;
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });

      show(0);
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-nk-accordion]').forEach((root) => {
      if (root.dataset.nkReady) return;
      root.dataset.nkReady = '1';

      const buttons = Array.from(root.querySelectorAll('.nk-accordion__button'));
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const open = button.getAttribute('aria-expanded') === 'true';
          buttons.forEach((other) => other.setAttribute('aria-expanded', 'false'));
          button.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }

  function initFilters() {
    document.querySelectorAll('[data-nk-filter-toggle]').forEach((toggle) => {
      if (toggle.dataset.nkReady) return;
      toggle.dataset.nkReady = '1';

      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      const sign = toggle.querySelector('[data-nk-filter-sign]');
      if (!panel) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (sign) sign.textContent = open ? '−' : '+';
      });
    });
  }

  function initProductForms() {
    document.querySelectorAll('[data-nk-product-form]').forEach((form) => {
      if (form.dataset.nkReady) return;
      form.dataset.nkReady = '1';

      form.addEventListener('submit', async (event) => {
        if (!window.fetch) return;
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;

        try {
          const response = await fetch(form.dataset.addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          if (!response.ok) throw new Error('add failed');

          const cart = await (await fetch(form.dataset.cartUrl, { headers: { Accept: 'application/json' } })).json();
          document.querySelectorAll('[data-nk-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
          });
          /* The cart links (bar and menu) are hidden while the cart is empty.
             While the cart holds a work the currency joins the language button
             and the language panel. */
          const filled = cart.item_count > 0;
          document.querySelectorAll('[data-nk-cart-link]').forEach((link) => {
            link.hidden = !filled;
          });
          document.querySelectorAll('[data-nk-cart-currency]').forEach((el) => {
            el.hidden = !filled;
          });

          const actions = form.closest('[data-nk-product-actions]');
          if (actions) {
            form.hidden = true;
            const view = actions.querySelector('[data-nk-view-cart]');
            const note = actions.querySelector('[data-nk-note]');
            if (view) view.hidden = false;
            if (note && note.dataset.inCart) note.textContent = note.dataset.inCart;
          }
        } catch (error) {
          /* Fall back to a normal form post, which lands on the cart page. */
          form.dataset.nkReady = 'fallback';
          HTMLFormElement.prototype.submit.call(form);
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  }

  function initLightbox() {
    const box = document.querySelector('[data-nk-lightbox]');
    if (!box || box.dataset.nkReady) return;
    box.dataset.nkReady = '1';

    const items = Array.from(document.querySelectorAll('[data-nk-lightbox-scope] [data-nk-lb]'));
    if (items.length === 0) return;

    const image = box.querySelector('[data-nk-lb-image]');
    const title = box.querySelector('[data-nk-lb-title]');
    const caption = box.querySelector('[data-nk-lb-caption]');
    const count = box.querySelector('[data-nk-lb-count]');
    const pad = (n) => String(n).padStart(2, '0');
    let index = 0;
    let opener = null;

    /* Ask the CDN for a width that fits the stage instead of the largest version. */
    const stage = box.querySelector('[data-nk-lb-stage]');
    const sized = (url) => {
      if (!/[?&]width=\d+/.test(url)) return url;
      const wanted = Math.ceil(((stage.clientWidth || window.innerWidth) * Math.min(window.devicePixelRatio || 1, 2)) / 400) * 400;
      return url.replace(/([?&]width=)\d+/, '$1' + Math.max(800, Math.min(2400, wanted)));
    };
    const loaded = new Set();
    const preload = (i) => {
      const url = sized(items[(i + items.length) % items.length].dataset.full);
      if (loaded.has(url)) return;
      const img = new Image();
      img.onload = () => loaded.add(url);
      img.src = url;
    };

    const show = (i) => {
      index = (i + items.length) % items.length;
      const current = index;
      const data = items[index].dataset;
      const full = sized(data.full);
      const thumb = items[index].querySelector('img');

      /* Show the grid image at once, then swap in the sharp version when it has arrived. */
      if (loaded.has(full)) {
        image.src = full;
      } else {
        if (thumb && (thumb.currentSrc || thumb.src)) image.src = thumb.currentSrc || thumb.src;
        const large = new Image();
        large.onload = () => {
          loaded.add(full);
          if (index === current && !box.hidden) image.src = full;
        };
        large.src = full;
      }
      preload(index + 1);
      preload(index - 1);
      image.alt = data.title || '';
      title.textContent = data.title || '';
      caption.textContent = data.caption || '';
      count.textContent = pad(index + 1) + ' / ' + pad(items.length);
      box.setAttribute('aria-label', data.title || '');
    };
    const open = (i) => {
      opener = items[i];
      box.hidden = false;
      show(i);
      box.querySelector('[data-nk-lb-close]').focus();
    };
    const close = () => {
      box.hidden = true;
      if (opener) opener.focus();
    };

    items.forEach((item, i) => {
      item.addEventListener('click', () => open(i));
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(i);
        }
      });
    });

    box.querySelector('[data-nk-lb-stage]').addEventListener('click', () => show(index + 1));
    box.querySelector('[data-nk-lb-next]').addEventListener('click', () => show(index + 1));
    box.querySelector('[data-nk-lb-prev]').addEventListener('click', () => show(index - 1));
    box.querySelector('[data-nk-lb-close]').addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (box.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight') show(index + 1);
      if (event.key === 'ArrowLeft') show(index - 1);
    });
  }

  function init() {
    initLightbox();
    initHeader();
    initSlideshows();
    initAccordions();
    initFilters();
    initProductForms();
  }

  ready(init);
  document.addEventListener('shopify:section:load', init);
})();
